import { BooleanActionPropsType } from '../../interfaces/actions.interface';
import { ALERT_NEW_MESSAGE } from '../actionTypes';

export const alertNewMessage = (load: boolean): BooleanActionPropsType => {
  return {
    type: ALERT_NEW_MESSAGE,
    payload: load
  };
};
